"use client";
import React, { ReactNode, useState } from "react";
import { classNames } from "@lib/helpers";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Skeleton } from "@components/ui/skeleton";

interface CollapsableProps {
  title: string;
  children: ReactNode;
  id?: string;
}
const Collapsable = ({ title, children, id }: CollapsableProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="border rounded-lg scroll-mt-28" id={id}>
      <header
        className="py-5 px-6 sm:py-6 sm:px-7 flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen((prevState) => !prevState)}
      >
        <h3 className="text-neutral-900 text-lg font-semibold">{title}</h3>
        <button
          className={classNames(
            "p-2 rounded-full bg-neutral-100 transform",
            isOpen ? "rotate-180" : ""
          )}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen((prevState) => !prevState);
          }}
        >
          <ChevronDownIcon className="w-5 h-5" />
        </button>
      </header>
      {isOpen ? (
        <div className="pb-5 px-6 sm:pb-6 sm:px-7">{children}</div>
      ) : null}
    </div>
  );
};

export default Collapsable;

interface CollapsableLoadingProps {
  children: ReactNode;
}

export const CollapsableLoading = ({ children }: CollapsableLoadingProps) => {
  return (
    <div className="border rounded-lg scroll-mt-28">
      <header className="py-5 px-6 sm:py-6 sm:px-7 flex justify-between items-center cursor-pointer">
        {/* <h3 className="text-neutral-900 text-lg font-semibold">{title}</h3> */}
        <Skeleton className="h-7 w-32" />
        <button
          className={classNames(
            "p-2 rounded-full bg-neutral-100 transform rotate-180"
          )}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ChevronDownIcon className="w-5 h-5" />
        </button>
      </header>
      <div className="pb-5 px-6 sm:pb-6 sm:px-7">{children}</div>
    </div>
  );
};
